/**
 * Assigned-store scope for inventory users.
 *
 * 0 ids  → unscoped (admin / no store) — every store stays in the dropdown.
 * 1 id   → lock the UI to that store.
 * 2+ ids → dropdown shows only those assigned stores.
 *
 * `store_ids` on inventory_details is the source of truth. `store_id` is the
 * first-store fallback for older payloads.
 */

export function uniqueStoreIds(ids) {
  if (!Array.isArray(ids)) return [];
  return [...new Set(ids.map((id) => (id == null ? '' : String(id))).filter(Boolean))];
}

export function resolveAssignedStoreIds(inventoryDetails) {
  const fromArray = uniqueStoreIds(inventoryDetails?.store_ids);
  if (fromArray.length) return fromArray;
  const one = inventoryDetails?.store_id;
  return one ? [String(one)] : [];
}

export function storeRowId(row) {
  if (!row) return '';
  return String(row.store_id ?? row.id ?? '');
}

export function filterStoresByAssignment(stores, assignedIds) {
  const list = Array.isArray(stores) ? stores : [];
  if (!assignedIds?.length) return list;
  const allowed = new Set(assignedIds.map(String));
  return list.filter((s) => allowed.has(storeRowId(s)));
}

export function isStoreChoiceLocked(assignedIds) {
  return Array.isArray(assignedIds) && assignedIds.length === 1;
}
